export enum AccountPlanEnum {
  Pessoal_Encargos = 1,
  Funcionamento_Manutencao = 2,
  Transporte_Escolar = 3,
  Alimentacao_Escolar = 4,
  Obras_E_Instalações = 5
}
